module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "large"
  }, [_c('a', {
    attrs: {
      "id": "Page_i"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("Praise for Linda Lael Miller’s"), _c('br'), _vm._v("national bestselling series")])])])]), _c('a', {
    attrs: {
      "id": "Page_i"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('em', [_vm._v("SPRINGWATER SEASONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A DELIGHTFUL AND DELICIOUS MINISERIES. . . . "), _c('em', [_vm._v("Rachel")]), _vm._v(" will charm you, enchant you, delight you, and quite simply hook you. . . . "), _c('em', [_vm._v("Miranda")]), _vm._v(" is a sensual marriage-of-convenience tale guaranteed to warm your heart all the way down to your toes. . . . The warmth that spreads through "), _c('em', [_vm._v("Jessica")]), _vm._v(" is captivating. . . . The gentle beauty of the tales and the delightful, warmhearted characters bring a slice of Americana straight onto readers’ ‘keeper’ shelves. Linda Lael Miller’s miniseries is a gift to treasure.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“This hopeful tale is . . . infused with the sensuality that Miller is known for.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“All the books in this collection have the Linda Lael Miller touch. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Affaire de Coeur")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Nobody brings the folksiness of the Old West to life better than Linda Lael Miller.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("BookPage")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Another warm, tender story from the ever-so-talented pen of one of this genre’s all-time favorites.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Rendezvous")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Miller . . . create[s] a warm and cozy love story.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Publishers Weekly")])])]), _c('p', {
    staticClass: "break"
  }, [_c('a', {
    attrs: {
      "id": "Page_i"
    }
  }), _c('a', {
    attrs: {
      "id": "Page_ii"
    }
  })]), _c('a', {
    attrs: {
      "id": "Page_ii"
    }
  }, [_c('p', {
    staticClass: "large"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("Don’t miss these other marvelous Springwater novels . . .")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('em', [_vm._v("SPRINGWATER")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Heartwarming. . . . Linda Lael Miller captures not only the ambiance of a small Western town, but the need for love, companionship, and kindness that is within all of us. . . . "), _c('em', [_vm._v("Springwater")]), _vm._v(" is what Americana romance is all about.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A heartwarming tale with adorable and endearing characters.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Rendezvous")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('em', [_vm._v("A SPRINGWATER CHRISTMAS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A tender and beautiful story. . . . Christmas is the perfect time of year to return to Springwater Station and the unforgettable characters we’ve come to know and love. . . . Linda Lael Miller has once more given us a gift of love.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "large"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("Critical acclaim for Linda Lael Miller’s marvelous New York Times bestseller")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('em', [_vm._v("ONE WISH")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“[A] story rich in tenderness, romance, and love. Her protagonists are adorable, with a strength and courage that touched my heart. . . . Ms. Miller reminds us of a simpler time in which determined men and the strong women by their sides forged our future. An excellent book from an author destined to lead the romance genre into the next century.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Rendezvous")])])]), _c('p', [_c('a', {
    attrs: {
      "id": "Page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "Page_iii"
    }
  })]), _c('a', {
    attrs: {
      "id": "Page_iii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Heartwarming. . . . Fans of Miller’s Springwater Seasons series will not want to miss this enjoyable tale.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“An author who genuinely cares about her characters, Miller also expresses the exuberance of Western life in her fresh, human, and empathetic prose and lively plot.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I loved this book! Ms. Miller touches our hearts again in a very special way. Do not miss this wonderful story!”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Old Book Barn Gazette")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“[A] triumph. . . . "), _c('em', [_vm._v("One Wish")]), _vm._v(" is an entertaining Americana romance that shows why Linda Lael Miller has remained one of the giantesses of the industry for the past decade. The story line is crisp and filled with family conflict.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Harriet Klausner, Barnesandnoble.com ")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('em', [_vm._v("TWO BROTHERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A fun read, full of Ms. Miller’s simmering sensuality and humor, plus two fabulous brothers who will steal your heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Linda Lael Miller has gifted her fans with a book that is in actuality two novels in one. . . . Fans of Western romance will devour this 2-for-1 gift package from the ingenious Ms. Miller.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Compuserve Romance Reviews ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cd03978","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/front.vue
// module id = 57
// module chunks = 0